














import { defineComponent } from "@vue/composition-api";
import { PrivateLiveChatTransactionDetails } from "@scrile/api-provider/dist/api/PrivateLivechatsProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { $t } from "@/lib/i18nHelpers";
import { getDurationSymbols } from "@/lib/time";
import config from "@/config";
import FormatMoney from "@/components/FormatMoney";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionPrivateLiveChat",
  components: { TransactionView, FormatMoney },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  computed: {
    EXTENDED_FRACTIONAL_PART_LENGTH() {
      return config.EXTENDED_FRACTIONAL_PART_LENGTH;
    },
    details(): PrivateLiveChatTransactionDetails {
      return this.transaction.details;
    },
    duration(): string {
      const duration = Math.floor(
        new Date(this.details.endTime).getTime() - new Date(this.details.startTime).getTime()
      );
      if (duration < 0) return "";
      const durationSymbols = getDurationSymbols(duration);
      const hoursString = durationSymbols.h === 0 ? "" : `${durationSymbols.h} ${$t("hr")} `;
      const minutesString = durationSymbols.m === 0 ? "" : `${durationSymbols.m} ${$t("min")} `;
      const secondsString = `${durationSymbols.m} ${$t("sec")}`;

      return hoursString + minutesString + secondsString;
    },
    opponentName(): string {
      return (
        (this.details.privateLiveChat.providerId === this.transaction.userId
          ? this.details.privateLiveChat.consumer
          : this.details.privateLiveChat.provider
        )?.screenName ?? $t("User deleted")
      );
    },
  },
});
